export default {"src":"/_next/static/media/Logo.f95beffc.svg","height":51,"width":208,"blurWidth":0,"blurHeight":0};